import { xCheck } from './xCheck';
import { xGetFromToIndex } from './xGetFromToIndex';
export function xAbsoluteSum(array, options = {}) {
    xCheck(array);
    const { fromIndex, toIndex } = xGetFromToIndex(array, options);
    let sum = 0;
    for (let i = fromIndex; i <= toIndex; i++) {
        sum += Math.abs(array[i]);
    }
    return sum;
}
//# sourceMappingURL=xAbsoluteSum.js.map